import { render, staticRenderFns } from "./IconExportXls.vue?vue&type=template&id=2888c99d"
import script from "./IconExportXls.vue?vue&type=script&lang=js"
export * from "./IconExportXls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports